function copyClipboard() {
   

    function copyToClipboard() {
        const copyLink = document.querySelector('#copyToClipBoard');
        const url = copyLink.getAttribute('data-copy-url');
        if (!url) return;

        navigator.clipboard.writeText(url)
            .then(() => {
                console.log('Copied to clipboard:', url);
                document.getElementById('copyClipboardMesage').style.display = 'flex';
                setTimeout(function() {
                    document.getElementById('copyClipboardMesage').style.display = 'none';
                }, 2000);
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
        
    }

    const copyLink = document.querySelector('#copyToClipBoard');
    if(copyLink) {
        copyLink.addEventListener("click", copyToClipboard);
    };
    
}
